import { AssetReference } from './creativeset/element-asset';
import { WidgetEvent } from './widget-events';
export var InternalWidgetEvent;
(function (InternalWidgetEvent) {
    /** Event that occurs when the widget's view node has changed. */
    InternalWidgetEvent["ViewNodeChanged"] = "viewNodeChange";
})(InternalWidgetEvent || (InternalWidgetEvent = {}));
export var WidgetUnitValues;
(function (WidgetUnitValues) {
    WidgetUnitValues["Number"] = "number";
    WidgetUnitValues["Boolean"] = "boolean";
    WidgetUnitValues["Select"] = "select";
    WidgetUnitValues["Text"] = "text";
    WidgetUnitValues["Color"] = "color";
    WidgetUnitValues["Font"] = "font";
    WidgetUnitValues["Feed"] = "feed";
    WidgetUnitValues["Image"] = "image";
})(WidgetUnitValues || (WidgetUnitValues = {}));
export const WIDGET_PROPERTY_PREFIX = 'custom:';
